module.exports = __webpack_public_path__ + "img/icon-flash-sand.b3f86195.svg";